export default "__VITE_ASSET__09395b48__"